import React, { useContext } from "react";
import { AppContext } from "../contexts/AppContext";

const DeleteItem = ({ data }) => {
  const appContext = useContext(AppContext);
  let { onDelete = () => {}, item = {} } = data;
  const deleteHandler = () => {
    appContext.updateModalState();
    onDelete(item);
  };

  return (
    <div className="card-body">
      <div className="row">
        <div className="col-md-12">
          <p className="delete-head">
            Are you sure you want to delete <b>{item?.name || "this item"}</b>?
          </p>
        </div>
        <div className="col-md-12">
          <button className="btn btn-primary modal-btn" onClick={deleteHandler}>
            Yes, Delete
          </button>
          <button
            className="btn btn-outline-primary prime-btn mx-3"
            onClick={() => {
              appContext.updateModalState();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteItem;
